import { Accordion, AccordionTab } from 'primereact/accordion';
import { FaChevronDown } from 'react-icons/fa';
import React, { useEffect, useRef, useState } from 'react';
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';
import { UserSummaryType } from '../../../../api/types/user/user-summary.type';
import { Dialog } from 'primereact/dialog';
import { AddNewDocDialog } from './componenets/add-new-doc-dialog';
import globalUserPage from '../../../../stores/global-user-page';
import { DocFeedbackItem } from './componenets/doc-feedback-item';
import { DocDetails } from '../../../../api/types/docs/doc-details';
import dateUtils from '../../../../utils/date-format';
import { AddNewDocFeedback } from './componenets/add-new-doc-feedback';
import { DocFeedbackStatusDB } from '../../../../api/types/docs/doc-feedback-status';
import { observer } from 'mobx-react-lite';
import { UserType } from '../../../../api/types/user/user-type';
import appApi from '../../../../api/app-api';

interface UserPageDocsDataModel {
  user: UserSummaryType;
  loadUserDocuments?: () => any;
}
export const UserPageDocs: React.FC<UserPageDocsDataModel> = observer(
  ({ user, loadUserDocuments }) => {
    const stepperRef = useRef(null);
    const [displayAddDialog, setDisplayAddDialog] = useState(false);

    const [addFeedbackIndex, setAddFeedbackIndex] = useState<number | null>(
      null,
    );

    //const docs: DocDetails[] = globalUserPage?.studentDetails?.docs ?? [];

    const [docs, setDocs] = useState<DocDetails[]>(
      user.role === UserType.STUDENT
        ? globalUserPage?.studentDetails?.docs
        : user.role === UserType.LECTURER
          ? globalUserPage?.lecturerDetails?.docs
          : [],
    );

    useEffect(() => {
      setDocs(
        user.role === UserType.STUDENT
          ? globalUserPage?.studentDetails?.docs
          : user.role === UserType.LECTURER
            ? globalUserPage?.lecturerDetails?.docs
            : [],
      );
    }, [
      globalUserPage?.studentDetails?.docs,
      globalUserPage?.lecturerDetails?.docs,
    ]);

    const getTag = (status: DocFeedbackStatusDB) => {
      switch (status) {
        case DocFeedbackStatusDB.Approved:
          return <Tag severity={'success'} value={'אושר'} />;
        case DocFeedbackStatusDB.Init:
          return <Tag severity={'warning'} value={'ממתין לתגובה'} />;
        case DocFeedbackStatusDB.Reject:
          return <Tag severity={'danger'} value={'נדחה, ממתין לתגובה'} />;
      }
    };

    return (
      <div style={{ width: '100%' }}>
        <Dialog
          header="יצירת דרישה למסמך"
          visible={displayAddDialog}
          onHide={() => setDisplayAddDialog(false)}
          style={{
            width: '500px',
            backgroundColor: 'white',
            borderRadius: '8px',
          }}
        >
          <AddNewDocDialog
            programs={globalUserPage?.studentDetails?.programs}
            userId={user.id}
            user={user}
            onHide={async () => {
              // Refresh user details to get updated payment services
              setDisplayAddDialog(false);
            }}
          />
        </Dialog>
        <Button
          label={'הוספת מסמך'}
          onClick={() => setDisplayAddDialog(true)}
        />
        <Accordion
          style={{ direction: 'ltr', width: '100%' }}
          expandIcon={(options) => (
            <FaChevronDown
              style={{
                transform: options.isActive ? 'rotate(0deg)' : 'rotate(90deg)',
                transition: 'transform 0.3s',
                marginLeft: '8px',
              }}
            />
          )}
          collapseIcon={(options) => (
            <FaChevronDown
              style={{
                transform: options.isActive ? 'rotate(90deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s',
                marginLeft: '8px',
              }}
            />
          )}
        >
          {docs?.map((docItem, docIndex) => (
            <AccordionTab
              headerStyle={{ direction: 'rtl' }}
              style={{ direction: 'rtl' }}
              headerTemplate={() => {
                return (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      width: '100%',
                      alignItems: 'center',
                    }}
                  >
                    <div>
                      <div
                        style={{
                          direction: 'rtl',
                          display: 'flex',
                          flexDirection: 'row',
                        }}
                      >
                        <div>{docItem.docMetadata.docName.toString()}</div>
                        {/*<div>{docItem.docMetadata.docName}</div>*/}
                        <div style={{ marginRight: '8px' }}>
                          {docItem.feedbacks.length
                            ? `(${docItem.feedbacks.length})`
                            : 'אין תגובות'}
                        </div>
                      </div>
                      <div style={{ fontWeight: 'normal' }}>
                        נוצר ב{' '}
                        {dateUtils.displayFormatDate(
                          docItem.docMetadata.createdAt,
                        )}
                      </div>
                    </div>
                    {getTag(
                      docItem.feedbacks.length > 0
                        ? docItem.feedbacks[docItem.feedbacks.length - 1].status
                        : DocFeedbackStatusDB.Init,
                    )}
                    {/*<Tag severity="warning" value="ממתין לאישור"></Tag>*/}
                  </div>
                );
              }}
              key={'tab.header'}
              header={'asdasd'}
              disabled={false}
            >
              {docItem.feedbacks.map((feedBackItem, index) => (
                <DocFeedbackItem
                  feedback={feedBackItem}
                  userId={user.id}
                  user={user}
                  index={index + 1}
                  isLast={index === docItem.feedbacks.length - 1}
                  isRejectItem={false}
                  setDocs={setDocs}
                  isAdminModeActive={true}
                />
              ))}
              <div style={{ display: 'flex', justifyContent: 'left' }}>
                <Button
                  label={'הוספת תגובה +'}
                  style={{
                    height: '30px',
                    display: 'flex',
                    justifyContent: 'left',
                  }}
                  severity={'secondary'}
                  outlined={true}
                  onClick={() => setAddFeedbackIndex(docIndex)}
                />
              </div>

              <Dialog
                header="הוספת תגובה למסמך"
                visible={addFeedbackIndex === docIndex}
                onHide={() => setAddFeedbackIndex(null)}
                style={{
                  width: '500px',
                  backgroundColor: 'white',
                  borderRadius: '8px',
                }}
              >
                <AddNewDocFeedback
                  userId={user.id}
                  docId={docItem.docMetadata.id}
                  onFinish={async () => {
                    loadUserDocuments && loadUserDocuments();
                    setAddFeedbackIndex(null);
                  }}
                />
              </Dialog>
              {/*{addFeedbackIndex === docIndex && (
              <AddNewDocFeedback
                userId={user.id}
                docId={docItem.docMetadata.id}
              />
            )}*/}
            </AccordionTab>
          ))}
        </Accordion>
      </div>
    );
  },
);
